import type { ListenerDoc } from "radio-shared";

/** Les gens qui écoutent en même temps que toi. C'est là qu'est le sel du truc. */
export function Listeners({ listeners }: { listeners: ListenerDoc[] }) {
  return (
    <div className="listeners" title={listeners.map((l) => l.name).join(", ")}>
      <div className="listeners__avatars">
        {listeners.slice(0, 8).map((l) =>
          l.photo ? (
            <img key={l.uid} className="avatar" src={l.photo} alt={l.name} />
          ) : (
            <span key={l.uid} className="avatar avatar--initial">
              {l.name.slice(0, 1).toUpperCase()}
            </span>
          ),
        )}
      </div>
      <span className="listeners__count">
        {listeners.length === 0
          ? "personne à l'écoute"
          : `${listeners.length} à l'écoute${listeners.length > 8 ? "" : ""}`}
      </span>
    </div>
  );
}
